import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanActivate {

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) { }

  isRoleAccepted(next): boolean {
    let response = false;
    let roles = next.data.roles as Array<string>;

    roles.forEach((role) => {
      console.log(role, this.sessionService.role.ability);
      if (this.sessionService.role.ability === role) {
        response = true;
      }
    });
    return response;
  }

  redirectSuperAdmin(next): void {
    if (this.sessionService.role.ability === 'super-admin' && next.data.animation === 'DashboardPage') {
      this.router.navigateByUrl(`/user/society/list`);
    }
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise((resolve, reject) => {
      if (this.sessionService.isSigned === true) {

        console.log("signed")

        this.sessionService.updatePermissions().then(() => {
          resolve(this.isRoleAccepted(next));
          this.sessionService.permissionsUpdated.next(true);
        });
      } else {
        console.log("not signed")
        this.sessionService.loadingPage.next(true);
        this.sessionService.retrieveSession().then((retrieved) => {
          if (retrieved === true) {
            this.redirectSuperAdmin(next);
            resolve(this.isRoleAccepted(next));
            this.sessionService.permissionsUpdated.next(true);
          } else {
            this.router.navigateByUrl(`/login`);
            resolve(false);
            this.sessionService.permissionsUpdated.next(false);
          }
          this.sessionService.loadingPage.next(false);
        });
      }
    });
  }

}
